import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" + Add Template ")
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 4 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-base" }, /*#__PURE__*/_toDisplayString(`Artwork Template`), -1)
const _hoisted_11 = {
  span: 6,
  class: "w-40"
}
const _hoisted_12 = {
  span: 6,
  class: "w-40"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Are you sure you want to delete artwork?", -1)
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("  Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_button, {
          onClick: _ctx.addDesign,
          type: "primary",
          title: "Add new Artwork Template"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_table, {
        data: _ctx.dataSet,
        stripe: "",
        fit: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: column.dataIndex,
              prop: column.dataIndex,
              label: column.title,
              "tooltip-effect": column.dataIndex,
              "min-width": column.minWidth,
              class: "font-bold"
            }, {
              default: _withCtx((scope) => [
                (column.title === 'Actions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.actions, (action) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `action-${action.type}`,
                          class: "px-1"
                        }, [
                          (action.type === 'edit')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: action.size,
                                onClick: ($event: any) => (_ctx.editDesign(scope.row, scope.$index)),
                                title: "Edit template"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["size", "onClick"]))
                            : _createCommentVNode("", true),
                          (action.type === 'delete')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                size: action.size,
                                type: "danger",
                                onClick: ($event: any) => (_ctx.delDesign(scope.$index)),
                                title: "Delete template"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Delete)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["size", "onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (column.dataIndex === 'position')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(`${
                  _ctx.options.find(s => s.value === scope.row[column.dataIndex])
                    .title
                }`), 1))
                    : (column.dataIndex === 'additional_cost')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " $" + _toDisplayString(scope.row[column.dataIndex]), 1))
                      : (
                column.dataIndex === 'template' ||
                column.dataIndex === 'mockupTemplate'
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (
                  scope.row[column.dataIndex] &&
                  scope.row[column.dataIndex] !== ''
                )
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "text-primary",
                                  href: "#",
                                  onClick: ($event: any) => (
                  _ctx.onDownloadTemplate(_ctx.imageUrl(scope.row[column.dataIndex]))
                )
                                }, " Download ", 8, _hoisted_8))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(scope.row[column.dataIndex]), 1))
              ]),
              _: 2
            }, 1032, ["prop", "label", "tooltip-effect", "min-width"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialog) = $event)),
      class: "font-bold",
      width: "45%",
      onClose: _ctx.close,
      top: "2vh"
    }, {
      title: _withCtx(() => [
        _hoisted_10
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_el_button, { onClick: _ctx.close }, {
            default: _withCtx(() => [
              _hoisted_15,
              _hoisted_16
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _hoisted_17,
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "25%",
          center: "",
          rules: _ctx.rules,
          ref: "artwork"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Position",
              class: "font-bold",
              prop: "position"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.position,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.position) = $event)),
                  placeholder: "Position"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.title,
                        value: item.value,
                        size: 25
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Name",
              class: "font-bold",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                  autocomplete: "off",
                  placeholder: "Enter artwork name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Width",
              class: "font-bold",
              prop: "width"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.width,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.width) = $event)),
                  autocomplete: "off",
                  type: "number",
                  placeholder: "Enter width"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Height",
              class: "font-bold",
              prop: "height"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.height,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.height) = $event)),
                  autocomplete: "off",
                  type: "number",
                  placeholder: "Enter height"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Format",
              class: "font-bold",
              prop: "format"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.format,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.format) = $event)),
                  autocomplete: "off",
                  type: "text",
                  placeholder: "Enter format"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "DPI",
              class: "font-bold",
              prop: "dpi"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.dpi,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.dpi) = $event)),
                  autocomplete: "off",
                  type: "number",
                  placeholder: "Enter DPI"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Template url",
              class: "font-bold",
              prop: "template"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.template,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.template) = $event)),
                  autocomplete: "off",
                  type: "text",
                  placeholder: "Your template file url"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Template file",
              class: "font-bold",
              prop: "template"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_UploadImage, {
                    accept: `image/*`,
                    multiple: false,
                    content: `Upload template`,
                    setData: _ctx.form,
                    data: _ctx.form.template,
                    onCallback: _ctx.callback
                  }, null, 8, ["setData", "data", "onCallback"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Mockup template",
              class: "font-bold",
              prop: "mockupTemplate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.mockupTemplate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.mockupTemplate) = $event)),
                  autocomplete: "off",
                  type: "text",
                  placeholder: "Insert your mockup file url"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Mockup file",
              class: "font-bold",
              prop: "mockupTemplate"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_UploadImage, {
                    accept: `image/*`,
                    multiple: false,
                    content: `Upload template`,
                    setData: _ctx.form,
                    data: _ctx.form.mockupTemplate,
                    onCallback: _ctx.callbackUploadMockupTemplate
                  }, null, 8, ["setData", "data", "onCallback"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Additional Cost",
              class: "font-bold",
              prop: "additional_cost"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.additional_cost,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.additional_cost) = $event)),
                  min: 0,
                  autocomplete: "off",
                  type: "number"
                }, {
                  prefix: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogConfirm.status,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogConfirm.status) = $event)),
      title: "Confirm",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, { onClick: _ctx.cancelDelete }, {
            default: _withCtx(() => [
              _hoisted_21,
              _hoisted_22
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.confirmDelete
          }, {
            default: _withCtx(() => [
              _hoisted_23,
              _hoisted_24
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_19
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}